import { get } from "lodash";
import { useContext, useMemo, useState } from "react";
import Loading from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { StoreContext } from "shared/store";
import graphql from "utils/api/graphql";
import { SUBSCRIPTION_TEMPLATES } from "utils/constants";
import Templates from "./Templates";

export const STEPPER_KEYS = {
  ADDITIONAL_INFORMATION: "ADDITIONAL_INFORMATION",
  PROOF: "PROOF",
  DOCUMENT: "DOCUMENT",
};
const Detail = (_) => {
  const { user } = useContext(StoreContext);
  const [organization, setOrganization] = useState(get(user, "organization"));

  useQuery(graphql.queries.ORGANIZATION, {
    skip:
      !get(user, "organization.id") ||
      !get(user, "organization.config.template"),
    variables: {
      where: { id: get(user, "organization.id") },
      exclude: [
        "networkPlan",
        "networkInsurancePlan",
        "users",
        "telecoms",
        "networkCoverage",
        "attachments",
        "insurancePlans",
        "broker",
        "counterpartyContracts",
      ],
    },
    onCompleted: ({ organization }) => {
      setOrganization(organization);
    },
  });
  const SubscriptionTemplate = useMemo(() => {
    if (!get(organization, "config")) return;
    const Template = get(
      Templates,
      SUBSCRIPTION_TEMPLATES[get(organization, "config.template")],
      Templates.Health,
    );
    return Template;
  }, [organization]);

  if (!organization) return <Loading />;
  return <SubscriptionTemplate config={get(organization, "config")} />;
};

export default Detail;
